import React from "react";
import { Box, Text } from "theme-ui";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowReviewOrderPage,
  setCustomisationCompleteModalShown,
} from "store/app/appSlice";
import get from "lodash/fp/get";

import * as styles from "./ModalCustomisationsComplete.styles";
import { Button } from "components";
import ModalCenter from "../ModalCenter";
import { useTranslation } from "hooks";

export default function ModalCustomisationsComplete({
  isTopMostModal,
  onClose,
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleGoToReview = () => {
    dispatch(setCustomisationCompleteModalShown(true));
    dispatch(setShowReviewOrderPage(true));
    onClose();
  };

  const handleModalClose = () => {
    dispatch(setCustomisationCompleteModalShown(true));
    onClose();
  };

  const { title, description } = useSelector(
    get(["app", "formData", "uiText", "customisationCompleteModal"])
  );

  return (
    <ModalCenter
      isTopMostModal={isTopMostModal}
      onClose={handleModalClose}
      maxWidthOverride={"480px"}
    >
      <Box sx={styles.contentContainer}>
        <Text variant="h4Light" sx={styles.modalTitle}>
          {title}
        </Text>
        <Text
          as="div"
          variant="copy3Light"
          sx={styles.descriptionText}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></Text>
        <Box sx={styles.buttonsContainer}>
          <Button
            variant="secondary"
            size="medium"
            isRound
            onClick={handleModalClose}
          >
            {t("keep customizing")}
          </Button>
          <Button
            type="submit"
            variant="primary"
            size="medium"
            isRound
            theme="dark"
            onClick={handleGoToReview}
          >
            {t("review")}
          </Button>
        </Box>
      </Box>
    </ModalCenter>
  );
}
